'use strict';
const angular = require('angular');

export class googleReviewsComponent {

  constructor($timeout) {
    'ngInject';

    this.$timeout = $timeout;
  }

  $postLink() {

  }

  $onInit() {
    this.$elementId = this.elementId || 'google-reviews';
    this.$header = this.header || 'Google Reviews';

    this.$timeout(_ => {
      jQuery(document).ready($ => {

        console.log(this.$elementId, this.placeId, this.$header);

        console.log("enter");

        if ($("#"+ this.$elementId).length == 0) {
          console.log("not found");
          return;
        }

        // Find a placeID via https://developers.google.com/places/place-id
        $("#"+ this.$elementId).googlePlaces({
          placeId: this.placeId,
          // the following params are optional (default values)
          header: "<h3>"+this.$header+"</h3>", // html/text over Reviews
          footer: '', // html/text under Reviews block
          maxRows: 5, // max 5 rows of reviews to be displayed
          minRating: 4, // minimum rating of reviews to be displayed
          months: ["Jan", "Feb", "Mär", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"],
          textBreakLength: "90", // length before a review box is set to max width
          shortenNames: true, // example: "Max Mustermann" -> "Max M."",
          moreReviewsButtonUrl: '', // url to Google Place reviews popup
          moreReviewsButtonLabel: 'Show More Reviews',
          writeReviewButtonUrl: '', // url to Google Place write review popup
          writeReviewButtonLabel: 'Write New Review',
          showProfilePicture: true
        });
      });
    },0);

  }
}

export default angular.module('conduuApp.googleReviews', [])
  .component('googleReviews', {
    template: '<div id="{{$ctrl.$elementId}}"></div>',
    bindings: {
      placeId: '@',
      elementId: '@',
      header: '@'
    },
    controller: googleReviewsComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/google-reviews/google-reviews.component.js